import {Button, Divider, Result, Spin} from "antd";
import React, {useContext, useEffect, useState} from "react";
import Api from "../utilis/api/service";
import Urls from "../utilis/api/Urls";
import {AxiosError, AxiosResponse} from "axios";
import AuthContext from "../utilis/contexts/AuthContext";
import AppContext from "../utilis/contexts/AppContext";
import InfiniteScroll from "react-infinite-scroll-component";
import {MdOutlinePayment,MdShowChart} from "react-icons/md"
import {CiSquareQuestion} from "react-icons/ci"
import {TfiWrite} from "react-icons/tfi"
import {FrownOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import BillCard from "../components/BillCard";
import LocalStorage from "../utilis/tools/LocalStorage";
import localStorage from "../utilis/tools/LocalStorage";
import ReactApexChart from "react-apexcharts";
import {array} from "yup";

const Bills = () => {
    const authContext = useContext(AuthContext)
    const appContext = useContext(AppContext)
    const Token=LocalStorage.getToken();
    const [bills, setBills] = useState<Array<object>>([]);
    const [avrage,setAverage]=useState<Array<any>>([])
    const [labels,setLabels]=useState<Array<any>>([])
    const options: ApexCharts.ApexOptions = {
        chart: {
            type: 'line',
            toolbar: {
                show: false
            },



        },
        markers: {
            size: 6,
            colors: undefined,
            strokeColors: '#fff',
            strokeWidth: 2,
            strokeOpacity: 0.9,
            strokeDashArray: 0,
            fillOpacity: 1,
            discrete: [],
            shape: "circle",

            offsetX: 0,
            offsetY: 0,
            onClick: undefined,
            onDblClick: undefined,
            showNullDataPoints: true,

        },
        xaxis: {
            type: "category",
            categories:labels,
            labels: {
                show: true,
                rotate: -45,
                rotateAlways: false,
                hideOverlappingLabels: true,
                showDuplicates: false,
                trim: false,
                minHeight: undefined,
                maxHeight: 120,
                style: {
                    colors: [],
                    fontSize: '11px',
                    fontFamily: 'iranSans',
                    fontWeight: 400,
                    cssClass: 'apexcharts-xaxis-label',
                },
                offsetX: -30,
                offsetY: 47,}

        },
        yaxis:{

            labels: {

                style: {
                    colors: [],
                    fontSize: '11px',
                    fontFamily: 'iranSans',
                    fontWeight: 400,
                    cssClass: 'apexcharts-xaxis-label',
                },
                offsetX: -30,
                offsetY: 0,}
        }

    };
    const handleChartData=(data:any)=>{
        let chartData: number[]=[];
        let chartLabels: string[]=[];
        data.forEach((item:any,index:number)=>{
            chartData.push(+item.average_consumption)
            chartLabels.push(item.current_date)
        });
       setAverage(chartData);
        setLabels(chartLabels)
    }
    const series = [ {
        data: avrage,
        name:'میانگین مصرف'
    }]
    const [state, setState] = useState<any>({
        items: [],
        hasMore: false
    })
    useEffect(() => {
        if (bills.length) {
            setState({
                items: bills.slice(0, 30),
                hasMore: bills.length > 30
            })
        }
    }, [bills])
    const fetchMoreData = () => {
        if (!state.hasMore) {
            return;
        }

        setTimeout(() => {
            setState({
                items: state.items.concat(bills.slice(state.items.length, state.items.length + 30 > bills.length ? bills.length : state.items.length + 30)),
                hasMore: state.items.length + 30 < bills.length
            });
        }, 1000);
    };

    useEffect(() => {

        if (Token) {
            appContext.handleLoading(true)

            Api.post(Urls.GetBillHistory, {
                Cellphone: authContext.user.cellphone,
                BillId: LocalStorage.getBranchInfo().bill_id,
                FileNumber:LocalStorage.getFileNumber(),
            }, {
                headers: {
                    "Authorization": Token.token_type + " " + Token.access_token
                }
            }).then((response: AxiosResponse) => {

                const {data} = response;
                const {Data} = data;
                const {bills} = Data;
                setBills(bills)
                handleChartData(bills)
            }).catch((e: AxiosError) => {

            }).finally(() => {

                appContext.handleLoading(false)


            })
        }
    }, [])
    return <>

        {bills.length>0 &&<div className="bills-cart">      <Divider><h3 className="font-bold ">میانگین مصرف</h3></Divider> <div className="w-full overflow-hidden">
            <ReactApexChart options={options}  series={series} type="line" height={350}/>
        </div></div>}
        <div className="w-full bill-title">
            <Divider className=""><h3 className="font-bold "> لیست قبض ها</h3></Divider>
            <Button type="primary" className="my-2" onClick={()=>{window.print();}}>چاپ</Button>
        </div>

        {bills.length>0 &&   <InfiniteScroll
            dataLength={state.items.length}
            next={fetchMoreData} className="overflow-auto min-h-[500px]"
            hasMore={state.hasMore}
            loader={<div className="flex w-full mb-3 justify-center"><Spin/></div>}

        >
            {state.items.map((item: any, index: number) => (
                <BillCard index={index+1} item={item} key={'bill-item-'+index} />
            ))}
        </InfiniteScroll>}
        {!bills.length && !appContext.isLoading && <Result
            icon={<FrownOutlined />}
            subTitle="هیچ قبضی یافت نشد."

        />}

    </>
}
export default Bills;